<template>
  <div>
    <v-card-actions class="justify-space-around">
      <v-btn text @click="prev">
        <v-icon color="#29284c">mdi-chevron-left</v-icon>
      </v-btn>
      <v-item-group v-model="onboarding" class="text-center" mandatory>
        <v-item v-for="n in step.length" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
          <v-btn icon @click="toggle" :input-value="active">
            <v-icon color="#29284c">mdi-record</v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-btn text @click="next">
        <v-icon color="#29284c">mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
    <v-window v-model="onboarding">
      <v-row align="center" justify="center">
        <v-window-item v-for="(item, index) in step" :key="'Component ' + item + index">
          <v-card
            max-width="700"
            width="80vw"
            min-height="500"
            class="px-5 py-3 overflow-x-hidden overflow-y-auto custom-scroll"
            max-height="80vh"
          >
            <v-card-title class="py-0">{{ componentTranslation[item] }}</v-card-title>
            <component :direction="direction" :is="item" :ref="item" :location="location" />
          </v-card>
        </v-window-item>
      </v-row>
    </v-window>
  </div>
</template>
<script>
export default {
  props: {
    step: {
      type: Array,
      required: false,
    },
    value: {
      type: Boolean,
      required: true,
    },
    direction: {
      required: false,
      type: String,
      default: "",
    },
    location: {
      type: String,
      default: "LIVE",
    },
  },
  data() {
    return {
      onboarding: 0,
      componentTranslation: {
        Introduction: "Introduction",
        Vocabulary: "Vocabulary",
        Listening: "Listening",
        Transcript: "Pronunciation",
        "Grammar Introduction": "Sentence Structure",
        "Grammar Exercise": "Sentence Structure Exercise",
        Speaking: "Speaking",
        "Transcript ": "Audio Transcript ",
        Pronunciation: "Pronunciation",
        Homework: "Homework",
      },
    };
  },
  methods: {
    next() {
      this.onboarding = this.onboarding + 1 === this.step.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.step.length - 1 : this.onboarding - 1;
    },
  },
  watch: {
    value(val) {
      if (!val) {
        Object.keys(this.$refs).forEach((element) => {
          this.$refs[element][0].restoreData();
        });
      } else {
        Object.keys(this.$refs).forEach((element) => {
          this.$refs[element][0].create();
        });
      }
    },
  },
  created() {
    let componentDef = {
      Introduction: "Introduction",
      Vocabulary: "Vocabulary",
      Listening: "Audio Text",
      Transcript: "Audio Transcript",
      "Grammar Introduction": "Grammar Introduction",
      "Grammar Exercise": "Grammar Exercise",
      Speaking: "Speaking",
      "Transcript ": "Audio Transcript ",
      Pronunciation: "Pronunciation",
      Homework: "Homework",
    };
    this.step.forEach(
      (element) =>
        (this.$options.components[element] = () => import(`./${componentDef[element]}.vue`)),
    );
  },
};
</script>
